<button (click)="openConfirmation(deleteVisite)" class="btn-annule btn btn-secondary mx-1">
  <i class="icon-search"></i><span>Annuler la visite</span></button>
<ng-template #deleteVisite let-modal class="modal-share p-3">
  <div class="modal-header container border-0 pt-3">
    <button type="button" class="btn-close btn-close-black me-1" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body  p-0">
    <div class="text-center mb-5">
      <form action="" id="calendarFormUser">
        <h2>Annuler la visite</h2>
        <p class="text-center">
          Etes-vous sûr de vouloir annuler la visite ?
        </p>
        <div class=" text-center">
          <button class="btn btn-gold mx-2" (click)="onCancelVisit(visiteId)">Oui</button>
          <button (click)="modal.dismiss('Cross click')" class="btn btn-primary mx-2">Non</button>
        </div>
      </form>
    </div>
  </div>
</ng-template>


